import { Component, OnInit, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ProductService } from 'src/app/services/product.service';
import { ProductRelatedCardComponent } from 'src/app/products-related/components/product-related-card/product-related-card.component';
import { MatButtonModule } from '@angular/material/button';
import { ObiettivoEuropaListComponent } from 'src/app/obiettivo-europa-list/obiettivo-europa-list.component';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { fadeInUpAnimation } from 'src/app/shared/animations/animations';
import { RoutingService } from 'src/app/services/routing.service';
import { MareLoaderModule } from '@mare-common/ngx-mare-loader';

@Component({
  selector: 'app-section-products-related',
  standalone: true,
  imports: [CommonModule,
    ProductRelatedCardComponent,
    MatButtonModule,
    NgOptimizedImage,
    ObiettivoEuropaListComponent,
    SharedModule,
    TranslateModule,
    MareLoaderModule
  ],
  animations: [fadeInUpAnimation],
  templateUrl: './section-products-related.component.html',
  styleUrls: ['./section-products-related.component.scss']
})
export class SectionProductsRelatedComponent implements OnInit {
  
  // sections$ = signal<any[] | null>(null);
  products$ = signal<any[] | null>(null);
  productsRelated: any[] = [];
  loading$ = signal<boolean>(true);

  visibilityState: { [key: string]: string } = {
    titleIntro: 'inactive',
    relatedSection: 'inactive'
  };


  constructor(
    private productService: ProductService,
    // private router: Router,
    private routingService: RoutingService
  ) { }

  ngOnInit(): void {
    this.initProducts();
  }
  initProducts() {
    let params = {
      tags: 'promodashboard',
    }
    // this.productRelated = []
    this.productService.getProductsParams(params, false,true).then((products: any) => {
      console.log(products);
      this.productsRelated = products;
      this.loading$.set(false);
      // this.products$.set(products);
    }).finally(() => {
      this.loading$.set(false);
    });
  }

  clickOeAction(product: any) {
    console.log('clickOeAction');
    // this.router.navigate([environment.routingBasePath + '/product/' + product.sku]);
    this.routingService.navigate([environment.routingBasePath + '/product/' + product.sku]);
  }

  onVisibilityChanged(element: string, visible: boolean) {
    if(Object.keys(this.visibilityState).includes(element) && visible) {
      this.visibilityState[element] = visible ? '*' : 'inactive';
    }
  }

  
}
